export default "__VITE_ASSET__B$hmAHZX__"